export default __webpack_public_path__ + "static/media/Insert_TextField.f4e3bf50.svg";